import React, { useEffect, useState } from 'react';
import { Button, Groupper, Header, IconName } from 'react-frontier2';
import { Link } from 'react-router-dom';

interface CreatedGroupperProps{
	iconName?: IconName,
	title: string,
	text: string,
	subtext?: string,
	link?: string,
	buttonText?: string,
}

var CreatedGroupper = (props: CreatedGroupperProps)=>{
	return <Groupper title={props.title} style={{ width: 400, margin: 'auto' }} fitted>
		<div style={{ minHeight: 310, display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>
			<Header text={props.text} subtext={props.subtext} iconName={props.iconName || "check-circle"} iconStyle={{ marginBottom: 15 }} style={{ marginTop: 0 }} />
			{!!props.link && (
				<Button text={props.buttonText || 'Continuar'} style={{ display: 'block', margin: '0 auto', width: 200, marginTop: 5 }} color="black" as={Link} to={props.link} />
			)}
		</div>
	</Groupper>
}

export default CreatedGroupper;